import { createTheme, responsiveFontSizes } from '@mui/material';

const palette = {
  // Green as primary color
  primary: {
    main: '#A29FFF',
    dark: '#66649E',
    light: '#B4B2EB',
  },
  secondary: {
    main: '#291A64',
    dark: '#39383F',
    light: 'rgba(238, 234, 248, 0.75)',
  },
  text: {
    primary: '#39383F',
  },
  success: {
    main: '#9DD1A2',
  },
  common: {
    white: '#FFFFFF',
    black: '#000000',
  },
  background: {
    default: '#FBFBFF',
  },
  error: {
    main: '#DCB6B6',
  },
  grey: {
    '100': '#ECECEC',
    '200': '#C6C6C8',
    '300': '#A9A9A9',
    '400': '#797979',
  },
};

let theme = createTheme({
  // https://mui.com/components/app-bar/#enable-color-on-dark
  palette,
  typography: {
    h1: { fontSize: '35px', fontWeight: 200, color: '#433E62' },
    h2: { fontSize: '19px', fontWeight: 600, color: palette.text.primary },
    h3: { fontSize: '12px', fontWeight: 'bold', color: '#9EA0C2' },
    h4: { fontSize: '11px' },
    h5: { fontSize: '10px' },
    overline: { fontSize: '15px', color: '#9EA0C2', lineHeight: 'normal' },
    subtitle1: {
      fontSize: '12px',
      fontWeight: 400,
      color: palette.primary.dark,
    },
    subtitle2: { fontSize: '11px' },
    caption: { fontSize: '12px' },
    button: { fontSize: '13px' },
    fontFamily: ['Inter', '-apple-system', 'Roboto', 'sans-serif'].join(','),
  },
});
theme = responsiveFontSizes(theme);
export default theme;
